import { useIonRouter } from "@ionic/react";

export function useIonicQueryParam(param: string) {
  const router = useIonRouter();
  const queryParams = new URLSearchParams(router.routeInfo.search);
  return queryParams.get(param);
}
